import {
	Address,
	Carrier,
	Customer,
	Model,
	SalesOrder,
	Salesman,
	Status,
	User
} from ".";
import { formatDate, formatTime } from "kinnect-formatters";
import { uniqueByKey } from "kinnect-helpers";

export const OutboundFreightStatuses = {
	ASSIGNED: "Assigned",
	PICKING: "Started picking",
	PICKED: "Finished picking",
	RCED: "Ready to RCE",
	INVOICED: "Ready to invoice",
	CHECKED: "Ready to check off against invoice",
	SHIPPED: "Shipping/loading onto truck",
	COMPLETED: "Completed"
};

export default class OutboundFreight extends Model {
	get singularNoun() {
		return "outbound freight";
	}

	get pluralNoun() {
		return "outbound freight list";
	}

	get mutations() {
		return {
			address: Address,
			carrier: Carrier,
			customer: Customer,
			salesOrders: SalesOrder,
			salesman: Salesman,
			statuses: Status,
			userAssigned: User,
			userCreatedBy: User
		};
	}

	get estimatedPickup() {
		let formattedDate;
		let formattedTime;

		if ( this.estimatedPickupDate ) {
			formattedDate = formatDate( this.estimatedPickupDate, "MMM d" );
		}

		if ( this.estimatedPickupTime ) {
			formattedTime = formatTime( this.estimatedPickupTime );
		}

		if ( formattedDate && formattedTime ) {
			return `${formattedDate} at ${formattedTime}`;
		} else if ( formattedDate ) {
			return formattedDate;
		} else if ( formattedTime ) {
			return formattedTime;
		}
	}

	get statusText() {
		return OutboundFreightStatuses[this.$.status];
	}

	get salesOrderErrors() {
		if ( this.salesOrders ) {
			const errors = this.salesOrders.reduce(
				( total, current ) => total.concat( current.errors || [] ),
				[]
			);

			return uniqueByKey( errors, "id" );
		}
	}

	get salesOrderNumbers() {
		if ( this.salesOrders ) {
			return this.salesOrders.map( so => so.salesOrderNumber ).join( ", " );
		}
	}

	resource() {
		return "warehouse/outbound-freight";
	}
}
